import React, { FC, useState, useEffect } from 'react'
import styles from './Service.module.scss'
import { ServiceEntity } from '../../ducks/services/types'

const DELEVERY_LABELS = [
  {
    type: "stream",
    name: "HD版ストリーミング"
  },
  {
    type: "hd",
    name: "HD版ダウンロード + HD版ストリーミング"
  }
]


interface PropsType {
  service: ServiceEntity
}

const Service: FC<PropsType> = ({service}) => {
  return (
    <a className={ styles.service } href={service.URLsp} target="_blank" rel="noopener">
      <div className={ styles.imageContent }>
        {
          service.imageURL && service.imageURL.list ?
            <img src={ service.imageURL.list } /> :
            <span className={ styles.noImage }>No Image </span>
        }
      </div>
      <div className={ styles.detailContent }>
        <div className={ styles.title }>
          { service.title }
        </div>
        <div className={ styles.reviews }>
          <span className={ styles.icon }>
            {
              service.review &&
                Array(Math.floor(service.review.average)).fill("★")
            }
          </span>
          <span className={ styles.points }>
            {service.review ? service.review.average : '-'}点
          </span>
        </div>
        <ul className={ styles.types }>
          {
            service.prices.deliveries.delivery.map(delivery => {
              const label = DELEVERY_LABELS.find(label => label.type === delivery.type)
              if (!label) return
              return (
                <li className={ styles.type } key={ delivery.type }>
                  <span className={ styles.name }>{label.name}</span>
                  <span className={ styles.price }>{delivery.price}円</span>
                </li>
              )
            })
          }
        </ul>
        <ul className={ styles.labels }>
          {
            service.iteminfo.genre.map(genre => (
              <li className={ styles.label } key={genre.id}>{genre.name}</li>
            ))
          }
        </ul>
      </div>
    </a>  
  )
}

export default Service